import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SearchAndFilters = ({ onSearch, onFilter, onSort }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSort, setSelectedSort] = useState("recent");
  const [selectedTier, setSelectedTier] = useState("");

  const categoryOptions = [
    { value: "", label: "All Categories" },
    { value: "nutrition", label: "Nutrition & Diet" },
    { value: "fitness", label: "Fitness & Exercise" },
    { value: "mindfulness", label: "Mindfulness & Mental Health" },
    { value: "sleep", label: "Sleep & Recovery" },
    { value: "center-specific", label: "Center Discussions" },
    { value: "challenges", label: "Community Challenges" }
  ];

  const sortOptions = [
    { value: "recent", label: "Most Recent" },
    { value: "popular", label: "Most Popular" },
    { value: "trending", label: "Trending" },
    { value: "expert", label: "Expert Responses" },
    { value: "unanswered", label: "Unanswered" }
  ];

  const tierOptions = [
    { value: "", label: "All Members" },
    { value: "intro", label: "Intro Members" },
    { value: "all-access", label: "All Access" },
    { value: "flex", label: "Flex Members" },
    { value: "premium", label: "Premium Members" }
  ];

  const handleSearch = (value) => {
    setSearchTerm(value);
    onSearch(value);
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
    onFilter({ category: value, tier: selectedTier });
  };

  const handleSortChange = (value) => {
    setSelectedSort(value);
    onSort(value);
  };

  const handleTierChange = (value) => {
    setSelectedTier(value);
    onFilter({ category: selectedCategory, tier: value });
  };

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedCategory("");
    setSelectedSort("recent");
    setSelectedTier("");
    onSearch("");
    onFilter({ category: "", tier: "" });
    onSort("recent");
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Search Input */}
        <div className="flex-1">
          <div className="relative">
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
            />
            <Input
              type="search"
              placeholder="Search discussions, topics, or members..."
              value={searchTerm}
              onChange={(e) => handleSearch(e?.target?.value)}
              className="pl-10"
            />
          </div>
        </div>

        {/* Filters Row */}
        <div className="flex flex-col sm:flex-row gap-3 lg:w-auto">
          <Select
            options={categoryOptions}
            value={selectedCategory}
            onChange={handleCategoryChange}
            placeholder="Category"
            className="min-w-[140px]"
          />

          <Select
            options={sortOptions}
            value={selectedSort}
            onChange={handleSortChange}
            placeholder="Sort by"
            className="min-w-[120px]"
          />

          <Select
            options={tierOptions}
            value={selectedTier}
            onChange={handleTierChange}
            placeholder="Member Tier"
            className="min-w-[130px]"
          />

          {(searchTerm || selectedCategory || selectedTier || selectedSort !== "recent") && (
            <Button
              variant="outline"
              size="sm"
              onClick={clearFilters}
              className="whitespace-nowrap"
            >
              <Icon name="X" size={16} />
              <span className="ml-1 hidden sm:inline">Clear</span>
            </Button>
          )}
        </div>
      </div>
      {/* Active Filters Display */}
      {(searchTerm || selectedCategory || selectedTier) && (
        <div className="flex flex-wrap gap-2 mt-3 pt-3 border-t border-border">
          <span className="text-sm text-muted-foreground">Active filters:</span>
          
          {searchTerm && (
            <div className="flex items-center space-x-1 bg-primary/10 text-primary px-2 py-1 rounded-full text-xs">
              <Icon name="Search" size={12} />
              <span>"{searchTerm}"</span>
            </div>
          )}
          
          {selectedCategory && (
            <div className="flex items-center space-x-1 bg-secondary/10 text-secondary px-2 py-1 rounded-full text-xs">
              <Icon name="Tag" size={12} />
              <span>{categoryOptions?.find(opt => opt?.value === selectedCategory)?.label}</span>
            </div>
          )}
          
          {selectedTier && (
            <div className="flex items-center space-x-1 bg-accent/10 text-accent-foreground px-2 py-1 rounded-full text-xs">
              <Icon name="Award" size={12} />
              <span>{tierOptions?.find(opt => opt?.value === selectedTier)?.label}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchAndFilters;